<template>
  <v-app>
    <Progress></Progress>
    <app-navigation></app-navigation>
    <v-content transition="slide-x-transition">
      <Alert />
      <router-view></router-view>
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import AppNavigation from "@/components/AppNavigation";
import NavigationDrawer from "@/components/NavigationDrawer";
import AppToolbar from "@/components/AppToolbar";
import Progress from "./components/Progress";
import Footer from "./components/Footer";
import Alert from "./components/Alert";
export default {
  name: "App",
  components: {
    AppNavigation,
    Progress,
    Footer,
    Alert
  },
  mounted() {
    navigator.geolocation.getCurrentPosition(function(position) {
      localStorage.setItem(
        "location",
        JSON.stringify({
          longitude: position.coords.longitude,
          latitude: position.coords.latitude
        })
      );
    });
  }
};
</script>

<style lang="scss">
</style>